<template lang="pug">
    .m-0.p-0.h-100(:class="[isFanFestActive ? '' : '']")
        .row(style="height:90%")
          // VOD
          .col-1.p-0(:class="[isFanFestActive ? 'd-none' : '']")            
          .col.align-self-center.m-0.p-0(:class="[isFanFestActive ? 'd-none' : '']")
            b-overlay(:show='hasVODMenu' variant='dark')
              .embed-responsive.embed-responsive-16by9(@click='toggleVODMenu' :class="[isFanFestActive ? '' : '']")
                video#vici-video-element.embed-responsive-item(ref='video' @playing='isVODReady = true' @volumechange="didChangeVolume()" @timeupdate='checkForBumper()' @ended='onEnd()' :muted="shouldMute" autoplay :class="[isFanFestActive ? 'd-none' : '']" playsinline preload=auto)
              // VOD Menu
              template(v-slot:overlay)
                .container-float.h-100
                  #menuVOD(ref='menuVOD')
                    button.btn.btn-lg.btn-outline-light.d-block.mx-auto.my-3.text-uppercase.font-weight-bold(type='button' @click="processMenuSelection('fanfest-share')") Join FanFest
                    button.btn.btn-lg.btn-outline-light.d-block.mx-auto.my-3.text-uppercase.font-weight-bold(type='button' @click="processMenuSelection('open-dashboard')") Upload Video
                
                  form.m-4.d-none(ref='formRequestFanFest' @submit.prevent="processMenuAction('request-fanfest-access')")
                    .form-group
                      input.form-control(ref='formRequestFanFestName' type='text' placeholder='First Name' v-model.trim='fanfestScreenname')
                    .form-group
                      input.form-control(ref='formRequestFanFestEmail' type='text' placeholder='Email Address')
                    .form-group
                      input.form-control(ref='formRequestFanFestCode' type='text' placeholder='Access Code')
                    .form-group
                      button.btn.btn-outline-light.d-block.mx-auto.my-5.text-uppercase.font-weight-bold(type='submit') Request
                      // i.fas.fa-cloud-upload-alt.fa-4x.text-secondary()
                  
                  button.btn.btn-outline-danger.d-block.mx-auto.my-5.text-uppercase.font-weight-bold(type='button' @click='hasVODMenu = false') Back                    

          .col-1.p-0(:class="[isFanFestActive ? 'd-none' : '']")
          
          // FanFest
          .col-12.p-0.align-self-center(:class="[isFanFestActive ? '' : 'd-none']")
            .row.justify-content-center.h-100
              //.col-6.align-self-center
                div(ref='fanfestvideo' v-if='false')
              // Host  
              .col-6.align-self-center(:class="[this.$store.state.fanfest.hasHost ? '' : 'd-none']")
                  #fanfestHost.embed-responsive.mx-auto.embed-responsive-16by9                    
              
              // Streamers              
              .col.align-self-center.p-0(:class='fanfeststreamClassObject' ref='fanfeststreams')
                //.d-flex.justify-content-center()
                  video.fanfest-video-1(src='demo/fanfest-demo-player2.mp4' muted autoplay playsinline loop v-for="i in new Array(1)")

              //.col-12.align-self-center
                video.d-inline-flex.p-1(style="width:50%; position:relative;" src='demo/fanfest-demo-player2.mp4' muted autoplay playsinline loop v-for="i in new Array(2)")
              
              //.col-10.align-self-center
                video.d-inline-flex.p-1(style="width:50%; position:relative;" src='demo/fanfest-demo-player2.mp4' muted autoplay playsinline loop v-for="i in new Array(4)")

              //.col-10.align-self-center
                video.d-inline-flex.p-1(style="width:33%; position:relative;" src='demo/fanfest-demo-player2.mp4' muted autoplay playsinline loop v-for="i in new Array(9)")
          
          // Previous imp
          //.col-12.p-0.align-self-center(:class="[isFanFestActive ? '' : 'd-none']")
            .row.align-items-center.h-100(:class="[fanfestMemberCount > 3 && fanfestMemberCount <=5 ? 'm-5' : 'm-0']")
              .col-1.p-0(:class="[fanfestMemberCount === 1 ? '' : 'd-none']")
              .align-self-center(:class="fanfestClassObject")                          
                .embed-responsive.mx-auto.embed-responsive-16by9
                  video#fanfest1.embed-responsive-item(v-if='debugModeFanFest' src='demo/fanfest-demo-player2.mp4' muted autoplay playsinline loop)
                  #fanfest1.embed-responsive-item(v-else='debugModeFanFest')
              .col-1.p-0(:class="[fanfestMemberCount === 1 ? '' : 'd-none']")
              .col.align-self-center.p-2(:class="[fanfestMemberCount > 1 ? '' : 'd-none', fanfestMemberCount > 3 && fanfestMemberCount <=5 ? 'my-5' : '']")                                     
                .embed-responsive.mx-auto.embed-responsive-16by9.my-3
                  video#fanfest2.embed-responsive-item(v-if='debugModeFanFest' src='demo/fanfest-demo-fans-woman.mp4' muted autoplay playsinline loop)
                  #fanfest2.embed-responsive-item(v-else='debugModeFanFest')
                .embed-responsive.mx-auto.embed-responsive-16by9.my-3
                  video#fanfest3.embed-responsive-item(v-if='debugModeFanFest' src='demo/fanfest-demo-fans-man.mp4' muted autoplay playsinline loop)
                  #fanfest3.embed-responsive-item(v-else='debugModeFanFest')
                .embed-responsive.mx-auto.embed-responsive-16by9.my-3(:class="[fanfestMemberCount > 5 ? '' : 'd-none']")
                  video#fanfest5.embed-responsive-item(v-if='debugModeFanFest' src='demo/fanfest-demo-fans-woman.mp4' muted autoplay playsinline loop)
                  #fanfest6.embed-responsive-item(v-else='debugModeFanFest')
              .col.align-self-center.p-2(:class="[fanfestMemberCount > 3 ? '' : 'd-none']")
                .embed-responsive.mx-auto.embed-responsive-16by9.my-3
                  video#fanfest3.embed-responsive-item(v-if='debugModeFanFest' src='demo/fanfest-demo-fans-man.mp4' muted autoplay playsinline loop)
                  #fanfest4.embed-responsive-item(v-else='debugModeFanFest')
                .embed-responsive.mx-auto.embed-responsive-16by9.my-3
                  video#fanfest3.embed-responsive-item(v-if='debugModeFanFest' src='demo/fanfest-demo-fans-woman.mp4' muted autoplay playsinline loop)
                  #fanfest5.embed-responsive-item(v-else='debugModeFanFest')
                .embed-responsive.mx-auto.embed-responsive-16by9.my-3(:class="[fanfestMemberCount > 5 ? '' : 'd-none']")
                  video#fanfest6.embed-responsive-item(v-if='debugModeFanFest' src='demo/fanfest-demo-fans-man.mp4' muted autoplay playsinline loop)
                  #fanfest7.embed-responsive-item(v-else='debugModeFanFest')
          
          // Chat
          //.col-2.pb-1.bg-white 
            .d-flex.align-items-center.justify-content-center.h-100.p-1 Register To Join Chat
          // b-button.floating-button.d-flex.align-items-center
           i.mx-auto.d-block.fa.fa-x.text-dark.fa-1x(@click="console.log('click');" :class="[shouldMute ? '' : '']")
        
        // Footer
        Footer(:isFanFestActive="isFanFestActive" :shouldMute="shouldMute" :fanfestStreamingEnabled="fanfestStreamingEnabled" :screenName="fanfestScreenname" :fanfestViews="fanfestViews" @mute="playSound" @fanfest-members="checkFanFestMembers")
        //FanFestViewService(:videoList="fanfestViews" :screenName="fanfestScreenname" :shouldMute="shouldMute" :canStream="false" @fanfest-members="checkFanFestMembers")
</template>

<script>
import axios from "axios";
import Hls from "hls.js";
import Footer from "../components/Footer.vue";
import Parse from "../services/parse.js";
//import FanFestViewService from "../components/services/FanFestService.vue";

// const duration = 20 * (1000 * 60);

export default {
  name: "Video",
  data() {
    return {
      hls: undefined,
      url: "",
      currentDuration: -1,
      isVODReady: false,
      hasBumper: false,
      shouldReload: false,
      canFullscreen: false,
      didFullscreen: false,
      hasVODMenu: false,
      didCheckFanFestActive: false,
      isFanFestActive: false,
      fanfestViews: [],
      fanfestScreenname: undefined,
      fanfestCode: "",
      fanfestStreamingEnabled: false,
      fanfestMemberCount: 0,
      shouldMute: true,
      debugMode: false,
      debugModeFanFest: false
    };
  },
  computed: {
    fanfeststreamClassObject: function() {
      return {
        /* "col-12": this.fanfestMemberCount <= 2,
        "col-10": this.fanfestMemberCount > 2 */
      };
    }
    /* fanfestClassObject: function() {
      return {
        'col-12': this.fanfestMemberCount === 1,
        'col-8': this.fanfestMemberCount > 1 && this.fanfestMemberCount <=3,
        'col-6': this.fanfestMemberCount > 3
      }
    } */
  },
  props: {
    hasDevice: Boolean
  },
  components: {
    Footer
  },
  methods: {
    configVideo: function() {
      var organizerID = this.$route.params.organizer;
      axios
        .get(`${process.env.VUE_APP_CONFIG_ROOT}/${organizerID}/vod`)
        .then(response => {
          this.url = response.data.url;
          this.currentDuration = response.data.duration;
          console.log(`duration: ${this.currentDuration}`);
          if (this.currentDuration > 0) this.hasBumper = true;
          this.playVideo();
        })
        .catch(err => Promise.reject(err.message));
    },
    playVideo: function() {
      if (this.debugMode) {
        this.$refs.video.src = "demo/IMG_0606.mp4";
        this.$refs.video.loop = true;
        return;
      }

      if (this.hasDevice || this.$route.query.m == 1) this.shouldMute = false;

      if (!this.didCheckFanFestActive) return;

      console.log("Playing " + this.url);
      if (Hls.isSupported()) {
        this.hls = new Hls();
        this.hls.loadSource(this.url);
        this.hls.attachMedia(this.$refs.video);
      } else {
        this.$refs.video.src = this.url;
        this.$refs.video.addEventListener("loadedmetadata", function() {
          this.$refs.video.play();
        });
      }

      this.$refs.video.controls = true;

      if (this.$refs.video.muted) this.$refs.video.muted = this.shouldMute;

      if (this.debugModeFanFest)
        setTimeout(() => (this.isFanFestActive = true), 2000);
    },
    playSound: function() {
      this.shouldMute = !this.shouldMute;
    },
    didChangeVolume: function() {
      const vid = this.$refs.video;
      if (!vid.src || this.isFanFestActive) return;
      this.shouldMute = vid.muted ? true : false;
    },
    goBig: function() {
      const divTV = document.getElementById("app");

      if (!document.fullscreenElement) {
        try {
          // Chrome
          divTV.requestFullscreen();
        } catch (err) {
          // oops, Safari
          divTV.webkitRequestFullscreen();
        }
      }

      // this.didFullscreen = true;
      if (!this.isFanFestActive && this.$refs.video.paused)
        this.$refs.video.play();
    },
    toggleVODMenu: function() {
      if (!this.didFullscreen || !document.fullscreenElement) return;
      this.hasVODMenu = !this.hasVODMenu;
    },
    processMenuSelection: function(selection) {
      switch (String(selection)) {
        case "fanfest-share":
          this.$refs.menuVOD.classList.add("d-none");
          this.$refs.formRequestFanFest.classList.remove("d-none");
          break;
        case "open-dashboard":
          window.open("https://watch.vici.cloud");
          this.hasVODMenu = false;
          break;
        default:
          console.error("Didn't recognize menu selection");
      }
    },
    processMenuAction: function(action) {
      switch (String(action)) {
        case "request-fanfest-access":
          axios
            .post(`${process.env.VUE_APP_BACKEND}/app/live/request`, {
              name: this.$refs.formRequestFanFestName.value.trim(),
              email: this.$refs.formRequestFanFestEmail.value.trim(),
              code: this.$refs.formRequestFanFestCode.value.trim()
            })
            .then(response => {
              console.log(response);
            })
            .catch(err => Promise.reject(err.message));
          break;

        default:
          console.error("Didn't recognize menu selection");
      }

      this.hasVODMenu = false;
    },
    checkForBumper: function() {
      if (this.isFanFestActive) {
        if (!this.$refs.video.paused) this.$refs.video.pause();

        return;
      }

      var time = this.$refs.video.currentTime;

      //if (time < 10) return;
      console.log(`current time: ${this.$refs.video.currentTime}`);

      let timeLeft = this.currentDuration - time;
      if (
        this.hasBumper &&
        this.currentDuration > 0 &&
        time > 5 &&
        timeLeft < 20
      ) {
        this.currentDuration = -1; // Prevents repeat VOD configs when this event fires
        this.configVideo();
      }
    },
    onEnd: function() {
      console.log("video ending...");
      this.currentDuration = -1;
      if (this.shouldReload && !this.isFanFestActive) window.location.reload();
      else this.configVideo();
    },
    resetVideo: function() {
      console.log("Killing VOD references for GC...");
      //if (this.$refs.video)
      this.$refs.video.src = "";
      this.$refs.video.load();
      //if (this.hls)
      this.hls.destroy();
      window.removeEventListener("beforeunload", this.resetVideo);
    },
    startFanFest: function() {
      console.log("Starting Fanfest...");

      if (this.isFanFestActive === false) {
        /*
        fanfestWatch.join([
          document.getElementById("fanfest1"),
          document.getElementById("fanfest2"),
          document.getElementById("fanfest3"),
          document.getElementById("fanfest4")
        ]);*/

        this.isFanFestActive = true;
      }

      this.$refs.video.muted = true;
      this.$refs.video.pause();
      // this.shouldReload = true;
    },
    checkFanFestMembers: function(numMembers) {
      this.didCheckFanFestActive = true;

      console.log("Checking FanFest # of members...");
      this.fanfestMemberCount = numMembers;
      if (!this.isFanFestActive && numMembers > 0) this.startFanFest();
      else if (this.isFanFestActive && numMembers === 0) this.stopFanFest();
      else if (!this.$refs.video.src) this.playVideo();
    },
    stopFanFest: function() {
      console.log("Ending Fanfest...");

      if (this.fanfestStreamingEnabled)
        location.reload();
      else {
        this.isFanFestActive = false;
        this.$refs.video.muted = this.shouldMute;
        if (this.$refs.video.src)
          this.$refs.video.play();
        else 
          this.playVideo();
      }
    }
  },
  created: async function() {
    let config = await Parse.Config.get();
    this.fanfestCode = config.get("kFanFestCode");
    let fanfestCodeHost = config.get("kFanFestCodeHost");

    var queryData = this.$route.query;
    if (queryData.u) 
      this.fanfestScreenname = queryData.u;
    
    if (queryData.c == this.fanfestCode) {
      this.fanfestStreamingEnabled = true;
    }
    else if (queryData.c == fanfestCodeHost) {
      this.$store.commit('enableHost');
      this.fanfestStreamingEnabled = true;
    } 
  },
  mounted: function() {
    this.configVideo();

    window.addEventListener("beforeunload", this.resetVideo);
    //setTimeout(() => (this.shouldReload = true), duration);

    /* this.sockets.subscribe("startFanFest", () => {
      // this.startFanFest();
    });
    this.sockets.subscribe("stopFanFest", () => {
      // no longer requried, stops FF based on # of members
      // this.stopFanFest();
    }); */

    this.fanfestViews = [
      this.$refs.fanfeststreams
      /* document.getElementById("fanfest1"),
      document.getElementById("fanfest2"),
      document.getElementById("fanfest3"),
      document.getElementById("fanfest4"),
      document.getElementById("fanfest5"),
      document.getElementById("fanfest6"),
      document.getElementById("fanfest7") */
    ];

    loadExternalScript("https://kit.fontawesome.com/2c8f0ec015.js");
    /*
    fanfestWatch.join([
      document.getElementById("fanfest1"),
      document.getElementById("fanfest2"),
      document.getElementById("fanfest3"),
      document.getElementById("fanfest4")
    ]);

    if (fanfestWatch.count() > 0) {
      this.isFanFestActive = true;
      this.startFanFest();
    }*/
  }
};

function loadExternalScript(url) {
  let script = document.createElement("script");
  script.setAttribute("src", url);
  document.head.appendChild(script);
}
</script>

<style>
.fanfest-video-1 {
  display: inline-flex;
  padding: 1%;
  width: 85%;
  position: relative;
}

.fanfest-video-4 {
  display: inline-flex;
  padding: 1%;
  width: 50%;
  position: relative;
}

.fanfest-video-9 {
  display: inline-flex;
  padding: 1%;
  width: 33%;
  position: relative;
}

#vici-vod {
  position: relative;
}

.vid-square {
  object-fit: cover;
  width: 500px;
  height: 500px;
}

.floating-button {
  width: 6vh;
  height: 6vh;
  border-radius: 50%;
  box-shadow: 0 6px 10px 0 #666;
  transition: all 0.1s ease-in-out;

  background-color: purple;
  text-align: center;
  line-height: 70px;

  position: fixed;
  left: 2%;
  top: 10%;
}

.floating-button:hover {
  box-shadow: 0 6px 14px 0 #666;
  transform: scale(1.05);
}

.fanfest-loading {
  background-image: url("https://vici-resources.s3.amazonaws.com/loading.gif");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 50%;
}

.fanfest-bg {
  background-image: url("https://media.giphy.com/media/4Z0chP31wyE0Wu25Cx/giphy.mp4");
  background-size: cover;
}

.psg-bg {
  background-image: url("https://wallpaperset.com/w/full/c/e/9/57822.jpg");
  background-size: cover;
  background-position: center;
}
</style>
